import React from 'react'
import styles from './CardTitle.module.css'

/**
 * Card title for the Card
 */
type CardTitleProps = {
    /** The content to be rendered inside the container */
    children: React.ReactNode;
    /** Additional CSS classes for custom styling (optional) */
    className?: string;
    /** OnClick callback */
    onClick?: () => any;
    /** Variant of the card title (default: 'default') */
    variant?: 'default' | 'simple';
}

export function CardTitle({ children, className, onClick, variant = 'default' }: CardTitleProps) {
    const titleClasses = [
        styles.title,
        variant === 'simple' ? styles.simple : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={titleClasses} onClick={onClick}>
            {children}
        </div>
    )
}